export default "__VITE_ASSET__CM2TzR8c__"